export default __webpack_public_path__ + "965a122ea8a8cd3b345a215eac97fb4c.ttf";